module.exports = __webpack_public_path__ + "img/resources.6519f36a.svg";